export default "__VITE_ASSET__e75c487a__"